/** @module CollectionBook/SalesCollectionStateRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/EnumAction",
	"./_SalesCollectionStateMixin"
], function(declare,EnumAction,_SalesCollectionStateMixin) {

	return declare([EnumAction,_SalesCollectionStateMixin], {

		/**
		 * @override
		 * Apply the proper CSS per state
		 */
		_getRenderCSS: function(ctx, h) {
			return this.inherited(arguments) + " " + this.getSalesStateCss(ctx);
		}
	});
});